import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoThreeBars } from "react-icons/go";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import bndLogo from "../../assets/images/01.png"
import { toggleI18n } from '../../features/someFunctionality/funSlice';
import CartSide from '../sidebar/CartSide';
import Sidebar from '../sidebar/Sidebar';
import AccountMenu from './AccountMenu';
import { CgProfile } from "react-icons/cg";
import { MdOutlineFavoriteBorder } from "react-icons/md";
import SearchSide from '../sidebar/SearchSide';
import { BsFillPersonFill } from "react-icons/bs";

const Navmd = () => {
    const { wishlist } = useSelector((state) => state.wishlist);
    const { userInfo } = useSelector((state) => state.user);
    const [openNav, setOpenNav] = useState(false);
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const { i18n } = useTranslation();

    function changeLanguage(e) {
        i18n.changeLanguage(e.target.value);
        dispatch(toggleI18n(e.target.value));
        setOpenNav(false);
    }


    const { i18n: newI18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (newI18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [newI18n]);

    return (
        <div className='xl:hidden block sticky top-0 z-50 bg-white shadow-md'>
            <div className="flex py-2 px-3">
                <div className="flex-none w-auto h-14 ...">
                    <div className="h-full flex justify-center space-x-2">
                        <div className="cart-icon grid content-center">
                            <Sidebar mdmain={true} side="right" forItem="cart" >
                                <CartSide />
                            </Sidebar>
                        </div>
                        <div className='border my-2'></div>
                        {userInfo?.email ?
                            <div className="cart-icon h-full grid content-center">
                                <AccountMenu mdmain={true} userInfo={userInfo} />
                            </div>
                            :
                            <Link className='hover:text-inherit' to="/auth/register" >
                                <div className="cart-icon h-full grid content-center">
                                    <p className='h-full text-2xl'>
                                        <BsFillPersonFill className='text-gray-600' />
                                    </p>
                                </div>
                            </Link>

                        }

                    </div>
                </div>
                <div className="grow grid justify-items-center">
                    <div className="h-14">
                        <Link to="/">
                            <img className='h-full w-auto object-fill ' src={bndLogo} alt="" />
                        </Link>
                    </div>
                </div>
                <div className="flex-none w-14 h-14 ...">
                    <div className='h-full flex justify-center '>
                        <div className="h-full grid content-center px-2">
                            <SearchSide />
                        </div>
                        <button onClick={() => setOpenNav(!openNav)} className="flex-none px-2 ">
                            <GoThreeBars className='text-3xl' />
                            <span className="sr-only">Open Menu</span>
                        </button>
                    </div>

                    <div className={`${!openNav && 'hidden'} absolute top-0 left-0 right-0 z-50 flex flex-col p-2 pb-4 m-2 space-y-3 bg-white rounded shadow`}>
                        <div className="flex pt-2 px-3">
                            <div className="flex-none w-14 h-14 ...">
                                <div className="h-full flex justify-center space-x-5">
                                    <div className="cart-icon grid content-center">
                                        <div className='flex gap-2'>
                                            {
                                                wishlist.length > 0 && (
                                                    <div className="cart-icon grid content-center">
                                                        <Link to="/wishlist">
                                                            <button type="button" className="focus:outline-none inline-flex relative items-center p-2 text-sm font-medium text-center text-white">
                                                                <MdOutlineFavoriteBorder className='block text-2xl text-black hover:text-bnd-1' />
                                                                <span className="sr-only">Notifications</span>
                                                                <div className="inline-flex absolute -top-1 -right-0 rounded justify-center items-center w-auto px-1 h-5 text-xs font-semibold text-white bg-bnd-1">{wishlist ? wishlist.length : 0}</div>
                                                            </button>
                                                        </Link>
                                                    </div>
                                                )
                                            }

                                            <Sidebar side="right" forItem="cart" >
                                                <CartSide />
                                            </Sidebar>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="grow grid justify-items-center">
                                <div className="h-14">
                                    <Link to="/">
                                        <img className='h-full w-auto object-fill scale-125' src={bndLogo} alt="" />
                                    </Link>
                                </div>
                            </div>
                            <div className="flex-none p-1 h-14 w-14 justify-center content-center">
                                <div className="h-full grid content-center space-x-5">
                                    <button onClick={() => setOpenNav(!openNav)} className="self-end flex-none px-2 ml-2" >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24"
                                            stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                        <span className="sr-only">Close Menu</span>
                                    </button>
                                </div>

                            </div>
                        </div>

                        <ul className="space-y-0 overflow-auto ">
                            {/* <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white or-bnd-1'>All Over Perfume</li> */}
                            {/* <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>Perfume</li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>Floor Freshener...</li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>Perfume Oil</li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>Hair Mix</li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-normal font-poppins text-sm bg-bnd-1 text-white '>Special Day</li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-normal font-poppins text-sm bg-bnd-1 text-white '>Whole Sale </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-normal font-poppins text-sm bg-bnd-1 text-white '>Contact us</li> */}


                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.home')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/nav-filter/perfume" onClick={() => setOpenNav(false)} className='hover:no-underline  hover:text-amber-600'>{t('home.nav.perfume')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/nav-filter/allOverPerfume" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.All-Over-perfume')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/nav-filter/sleepingSpray" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.Sleeping-Spray')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/nav-filter/giftBox" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.Gift-box')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/nav-filter/floorFreshener" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.floor-Freshener')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/nav-filter/perfumeOil" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.Perfume-Oill')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/nav-filter/hairMix" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.Hair-Mix')}</Link>
                            </li>
                            {/* <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>Sleeping Spray</li>
                                    <li className='py-3 px-2 cursor-pointer text-gray-600 hover:text-amber-600'>Gift Box</li> */}
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/nav-filter/specialDay" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.Special-Dy')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/nav-filter/wholeSale" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.Whole-Sale')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                <Link to="/contact-us" onClick={() => setOpenNav(false)} className='hover:no-underline hover:text-inherit'>{t('home.nav.Contact-us')}</Link>
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>
                                {userInfo?.email ?
                                    <div className='grow flex'>
                                        <p className='focus:outline-none px-3 py-1 flex gap-1'>
                                            <CgProfile />  <AccountMenu userInfo={userInfo} />
                                        </p>
                                    </div>
                                    :
                                    <div className='grow flex'>
                                        <p className='focus:outline-none px-3 py-1 flex gap-1'>
                                            <Link className='hover:text-inherit' to="/auth" onClick={() => setOpenNav(false)} >{translate ? "SIGNUP" : "রেজিস্টেশন"}</Link> / <Link className='hover:text-inherit' to="/auth/register" onClick={() => setOpenNav(false)} >{translate ? "LOGIN" : "লগইন"}</Link>
                                        </p>
                                    </div>
                                }
                            </li>
                            <li className='py-2 px-2 border-b border-white cursor-pointer font-medium font-poppins text-md bg-bnd-2 text-white '>

                                <div className='flex'>
                                    <button onClick={changeLanguage} value='en' className='focus:outline-none border-r border-l border-amber-600 grid content-center px-3'>
                                        English
                                    </button>
                                    <button onClick={changeLanguage} value='bn' className='focus:outline-none border-r border-l border-amber-600 grid content-center px-3'>
                                        বাংলা
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navmd;